import React, { createContext, useContext, useEffect, useState } from 'react'

import { useLocalStorage } from 'hooks/useLocalStorage'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const FeatureFlagContext = createContext()

type Props = {
  children: React.ReactNode
}

const FeatureFlagContextProvider = ({ children }: Props) => {
  const [isUIRevampEnabled, setIsUIRevampEnabled] = useState<boolean>(true)
  return (
    <FeatureFlagContext.Provider value={[isUIRevampEnabled]}>
      {children}
    </FeatureFlagContext.Provider>
  )
}

const useFeatureFlag = () => {
  const featureFlag = useContext(FeatureFlagContext)
  if (featureFlag == null) {
    throw new Error('useFeatureFlag() called outside of a AuthProvider?')
  }

  return featureFlag
}

export { FeatureFlagContextProvider, useFeatureFlag }
